export const simulationOfferDetailsAmortizationSystemTextsMap = {
  PRICE: {
    subtitle: "Parcelas fixas",
    description:
      "Nessa modalidade chamada PRICE o cálculo do juros é feito sobre o valor total de crédito. As parcelas são iguais do inicio ao fim do contrato."
  },
  SAC: {
    subtitle: "Parcelas decrescentes",
    description:
      "Nessa modalidade chamada SAC o cálculo do juros é realizado mês a mês sobre o saldo devedor atualizado. As primeiras parcelas são maiores no começo e menores no final do contrato."
  }
}
